module.exports = "pegasus_template/assets/3column-card.png";